import { SPACE_TITLE_LIMIT } from '@gitbook/app-database';

/**
 * Build a translated space title from the source title and language code.
 */
export function getTranslatedSpaceTitle(sourceTitle: string, language: string): string {
    const suffix = ` (${language.toUpperCase()})`;
    const maxTitleLength = SPACE_TITLE_LIMIT - suffix.length;
    const trimmedTitle = sourceTitle.slice(0, maxTitleLength).trimEnd();
    return `${trimmedTitle}${suffix}`;
}
